var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shuffle_FILL0_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.2625 10.1248V9.3748H8.825L6.525 7.0873L7.05 6.5498L9.375 8.8498V7.2623H10.125V10.1248H7.2625ZM2.4 10.1248L1.875 9.5873L8.85 2.6123H7.2625V1.8623H10.125V4.7248H9.375V3.1498L2.4 10.1248ZM4.9375 5.4498L1.875 2.3998L2.4125 1.8623L5.475 4.9123L4.9375 5.4498Z",
    fill: "#246DCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.88da7b0b6457f080e3c13e971f463597.svg";
export { ForwardRef as ReactComponent };